import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  TextField,
  Grid,
  Card,
  CardMedia,
  CardActionArea,
  Box,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";

const tempImages = [
  "Balanced diet.jpg",
  "Dental chart.jpg",
  "Diet chart.jpg",
  "gum disease.jpg",
  "anatomy of heart.png",
  "Ankle fracture.png",
  "Ankle sprain.png",
  "bladder.png",
  "Brain circulation.png",
  "Brain.png",
  "Breast cancer.png",
  "Cancerous cell.png",
  "child_teeth.png",
  "Chronic bronchitis.png",
  "Complete digestive system.png",
  "Dental_teeth.png",
  "digestive.png",
  "Duodenum.png",
  "Emphysema.png",
  "Gastroesophageal reflux disease (GERD).png",
  "heart anatomy.png",
  "heart.png",
  "Hepatomegalie.png",
  "kidney.png",
  "Larynx front view.png",
  "Liver.png",
  "Lungs.png",
  "major veins.png",
  "Mouth.png",
  "Nasal cavity.png",
  "Pancreas.png",
  "pcos.png",
  "Peristalsis.png",
  "Pneumothorax.png",
  "Pulmonary circulation.png",
  "Pulmonary edema.png",
  "Pulmonary embolism.png",
  "Rectum.png",
  "salivary_glands.png",
  "Stomach ulcer.png",
  "Stomach.png",
  "Swallowing system.png",
  "Trachea and bronchi.png",
  "Uterus.png",
];

const ImageRepository = ({ handleImageUpload, doctorDepartment }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [modifiedList, setModifiedList] = useState([]);
  const [debouncedImages, setDebouncedImages] = useState([]);
  const [doctorDepartmentId, setDoctorDepartmentId] = useState(0);

  const [page, setPage] = useState(1);
  const observer = useRef(null);
  const lastImageRef = useRef(null);
  // import abc from "../../../assets/diagnostic_images/Cardiology"
  const authToken = sessionStorage.getItem("accessToken") || "";
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = { Authorization: `Bearer ${authToken}` };
  console.log("doctorDepartment", doctorDepartment);

  const fetchImages = async (departmentId) => {
    try {
      const res = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_medical_images_from_s3/`,
        // { filter },
        { id: departmentId, is_preloaded: 1 },
        { headers }
      );
      console.log("res-->", res.data.data);
      if (res.data.status === "Success") {
        const validNames = res.data.data.map((img) => img.file_name);
        // const validNames = tempImages; // Already array of filenames
        console.log("validNames", validNames);
        const modifiedList = validNames.map((name) => ({
          name: name,
          url: `/assets/diagnostic_images/${doctorDepartment}/${name}`,
        }));
        // .filter((img) => !!img.url);
        console.log("modifiedList", modifiedList);
        setModifiedList(modifiedList);
        setDebouncedImages(modifiedList.slice(0, 6));
        setPage(1);
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching images");
    }
  };

  const getDoctorDepartmentId = () => {
    return axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_department_list/`,
        {},
        { headers }
      )
      .then((res) => {
        if (res.data.status === "Success") {
          const doctorDepartmentObj = res.data.data.filter(
            (dept) => dept.name === doctorDepartment
          );
          return doctorDepartmentObj[0]?.id;
        } else {
          console.log("error in getting the department ");
          return null;
        }
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  };

  useEffect(() => {
    getDoctorDepartmentId()
      .then((departmentId) => {
        if (departmentId) {
          fetchImages(departmentId);
        } else {
          console.error("No department ID found");
        }
      })
      .catch((error) => {
        console.error("Error fetching doctor department or images:", error);
      });
  }, []);

  const loadMoreImages = useCallback(() => {
    const nextPage = page + 1;
    const newImages = modifiedList.slice(0, nextPage * 6);
    setDebouncedImages(newImages);
    setPage(nextPage);
  }, [modifiedList, page]);

  useEffect(() => {
    if (!lastImageRef.current) return;

    const observerCallback = (entries) => {
      if (
        entries[0].isIntersecting &&
        debouncedImages.length < modifiedList.length
      ) {
        loadMoreImages();
      }
    };

    const observerOptions = {
      root: null,
      rootMargin: "50px",
      threshold: 1,
    };

    const observerInstance = new IntersectionObserver(
      observerCallback,
      observerOptions
    );
    if (lastImageRef.current) observerInstance.observe(lastImageRef.current);

    return () => {
      if (lastImageRef.current)
        observerInstance.unobserve(lastImageRef.current);
    };
  }, [loadMoreImages, debouncedImages]);

  const handleSearch = () => {
    if (searchQuery.trim() === "") {
      setDebouncedImages(modifiedList.slice(0, 6));
    } else {
      const filtered = modifiedList.filter((img) =>
        img.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      console.log("searchQuery-->", searchQuery);
      console.log("filtered-->", filtered);
      setDebouncedImages(filtered);
    }
  };
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          backgroundColor: "white",
          pb: 1,
          pt: 1,
          display: "flex",
          alignItems: "center",
          gap: 2,
          marginLeft: "1%",
        }}
      >
        <TextField
          fullWidth
          size="small"
          label="Search Images"
          variant="outlined"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <Button variant="contained" onClick={handleSearch}>
          Search
        </Button>
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          mt: 2,
          pr: 1,
          height: "300px",
          marginLeft: "1%",
        }}
      >
        <Grid container spacing={2}>
          {debouncedImages.map((image, index) => (
            <Grid
              item
              xs={6}
              key={image.name}
              ref={index === debouncedImages.length - 1 ? lastImageRef : null}
            >
              <Card>
                <CardActionArea onClick={() => handleImageUpload(image.url)}>
                  <CardMedia
                    component="img"
                    height="140"
                    image={image.url}
                    alt={image.name}
                    loading="lazy"
                  />
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ImageRepository;
